import React, { useState } from "react";

import { FormButton } from "components";
import { LinearProgress } from "@mui/material";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";
import * as XLSX from "xlsx";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";
import { usuariosXServicio as titles } from "consts/titulos-de-tablas";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { clienteUsuarioGet } from "services/services-mia";
import moment from "moment";

const onboardStatus = [
    {
        onboardStatusCod: '',
        onboardStatusNombre: 'Todos'
    },
    {
        onboardStatusCod: 'Y',
        onboardStatusNombre: 'Sí'
    },
    {
        onboardStatusCod: 'N',
        onboardStatusNombre: 'No'
    }
];

const dateFilters = [
    {
        dateFilterCod: 'ALTA',
        dateFilterNombre: 'Fecha de Alta'
    },
    {
        dateFilterCod: 'ESTADO',
        dateFilterNombre: 'Fecha de Estado'
    },
];

export default function ExportModal({ updateList, servicio, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);
    const [progress, setProgress] = useState(0);

    const handleSubmit = async ({
        desde,
        hasta,
        onboard,
        fechaTipo
    }) => {
        const functions = {
            setSnackbarInfo,
            setInRequest,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };
        setInRequest(true);
        setProgress(0);
        const rows = [];
        let page = 1;
        const pageSize = 20000;
        let next = false;
        do {
            const { result, total, status } = await clienteUsuarioGet({
                merchantId: credentials?.merchantId,
                tipoRelacion: "S",
                servicioCod: servicio?.servicioCod,
                page: page,
                pageSize,
                fechaTipo,
                fechaDesde: desde,
                fechaHasta: hasta,
                usuarioTieneApp: onboard || null,
            }, credentials);

            if (status?.code !== 1) {
                functions.setIsOpen = () => { };
                handleResponse(
                    {
                        status: {
                            code: status.code,
                            errmsg: "Falló la exportación",
                            action: status.action
                        }
                    },
                    "Falló la exportación",
                    functions
                );
                setProgress(0);
                console.error('Falló la exportación:', status.errmsg)
                return;
            }

            result.forEach((usuario) => {
                rows.push({
                    [titles[0].headerName]: usuario.usuarioNombreCompleto,
                    [titles[1].headerName]: usuario.usuarioNroDeDocumentoX,
                    [titles[2].headerName]: usuario.tipoDeDocumentoCod,
                    [titles[3].headerName]: usuario.usuarioSexo,
                    [titles[4].headerName]: usuario.usuarioFechaDeNacimiento ? moment(usuario.usuarioFechaDeNacimiento).format("DD/MM/YYYY") : null,
                    [titles[5].headerName]: usuario.usuarioMail,
                    [titles[6].headerName]: usuario.rolNombre,
                    [titles[7].headerName]: usuario.usuarioId === null ? 'NO' : 'SI',
                    [titles[8].headerName]: usuario.usuarioFechaDeAlta ? moment(usuario.usuarioFechaDeAlta).format("DD/MM/YYYY") : null,
                    [titles[9].headerName]: usuario.relacionStatus,
                    [titles[10].headerName]: usuario.usuarioFecha,
                    'Versión': usuario.usuarioAPPVersion,
                })
            });
            console.info(`rows export(${page}):`, result.length)

            next = (page * pageSize) < total;

            setProgress(next ? (100 * page * pageSize / total) : 100)

            page++;
        } while (next)
        try {
            const worksheet = XLSX.utils.json_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            const dt = new Date();
            const dateString = `${dt.getFullYear()}${`${dt.getMonth() + 1}`.padStart(2, '0')}${`${dt.getDate()}`.padStart(2, '0')}${`${dt.getHours()}`.padStart(2, '0')}${`${dt.getMinutes()}`.padStart(2, '0')}`
            const fileName = `Usuarios-${servicio.servicioNombre}-${dateString}.xlsx`
            XLSX.writeFile(workbook, fileName, { compression: true });
        } catch (e) {
            functions.setIsOpen = () => { };
            handleResponse(
                {
                    status: {
                        code: 0,
                        errmsg: "Falló la exportación",
                        action: "E"
                    }
                },
                "Falló la exportación",
                functions
            );
            setProgress(0);
            console.error(e);
            return;
        }

        handleResponse(
            { status: { code: 1 } },
            "Exportado exitosamente",
            functions
        );
    };

    return (
        <Formik
            initialValues={{
                desde: new Date().toISOString().substring(0, 10),
                hasta: new Date().toISOString().substring(0, 10),
                onboard: '',
                fechaTipo: 'ALTA',
            }}
            validationSchema={
                yup.object({
                    desde: yup.date(FORM_ERROR_MESSAGES.date)
                        .required(FORM_ERROR_MESSAGES.required)
                        .max(yup.ref("hasta"), "No puede ser posterior a fecha hasta"),
                    hasta: yup.date(FORM_ERROR_MESSAGES.date)
                        .required(FORM_ERROR_MESSAGES.required)
                })
            }
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles['column-sm']}>
                    <FormikSelectInput
                        fullWidth={true}
                        name="onboard"
                        labelText="Onboard"
                    >
                        {onboardStatus.map(({ onboardStatusCod, onboardStatusNombre }) => (
                            <option
                                key={onboardStatusCod || 'Todos'}
                                data-id={onboardStatusCod}
                                value={onboardStatusCod}
                            >
                                {onboardStatusNombre}
                            </option>
                        ))}
                    </FormikSelectInput>
                    <FormikSelectInput
                        fullWidth={true}
                        name="fechaTipo"
                        labelText="Tipo de Fecha"
                    >
                        {dateFilters.map(({ dateFilterCod, dateFilterNombre }) => (
                            <option
                                key={dateFilterCod || 'Todos'}
                                data-id={dateFilterCod}
                                value={dateFilterCod}
                            >
                                {dateFilterNombre}
                            </option>
                        ))}
                    </FormikSelectInput>
                    <FormikTextInput
                        fullWidth={true}
                        name="desde"
                        labelText={"Desde"}
                        type="date"
                    />

                    <FormikTextInput
                        fullWidth={true}
                        name="hasta"
                        labelText={"Hasta"}
                        type="date"
                    />

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Exportar" }}
                        onCloseModal={closeModal}
                    />

                    {inRequest && (
                        <>
                            {progress === 0
                                ? <LinearProgress
                                    style={{
                                        width: "100%",
                                    }}
                                    color="secondary"
                                />
                                : <LinearProgress variant="determinate" value={progress}
                                    style={{
                                        width: "100%",
                                    }}
                                    color="secondary"
                                />
                            }
                            <small>
                                Esto puede tomar un tiempo
                            </small>
                        </>
                    )}
                </div>
            </Form>
        </Formik>
    );
}
